import api from "@/lib/api";
import { shouldReportError } from "@/lib/errorThrottle";

let installed = false;

/** Captura errores globales no controlados y los registra (auto-salud). */
export function installGlobalErrorReporting() {
  if (installed || typeof window === "undefined") return;
  installed = true;

  const report = (message, stack, meta) => {
    try {
      const payload = {
        message: String(message || "Error").slice(0, 1000),
        stack: String(stack || "").slice(0, 4000),
        route: window.location.pathname,
        type: "error",
        meta,
      };
      if (!shouldReportError(payload)) return; // throttle + dedupe
      api.post("/api/errors/log", payload).catch(() => {});
    } catch (err) {
      if (process.env.NODE_ENV !== "production") console.debug("errorReporter: no se pudo reportar el error", err);
    }
  };

  window.addEventListener("error", (e) => {
    if (e?.message) report(e.message, e.error?.stack, { kind: "window_error" });
  });

  window.addEventListener("unhandledrejection", (e) => {
    const reason = e?.reason;
    report(reason?.message || reason || "Unhandled promise rejection", reason?.stack, {
      kind: "unhandledrejection",
    });
  });
}
